import TypeIcon from "components/Dashboard/DoctorDashboard/attachments/components/type-icon";
import type { OrchidDriveFile } from "contexts/orchid-drive/types";
import messages from "messages";
import { ReactNode, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import getClasses from "utils/getClasses";
import getMIMETypeByFileName from "utils/getMIMETypeByFileName";
import { useBlockAttachments } from "../../scenes/note-fill-in/contexts/BlockAttachmentsContext";
import { useBlockType } from "../template-editor/components/block-type/contexts/BlockTypeContext";
import styles from "./BlockAttachments.module.scss";
import Delete from "./components/delete";

type Props = {
  id: string;
  mode: ReturnType<typeof useBlockType>["mode"];
};
const BlockAttachments = ({ id, mode }: Props) => {
  const { attachments, deleteEntry } = useBlockAttachments();

  const attachmentsById: OrchidDriveFile[] | undefined = useMemo(
    () => attachments[id],
    [attachments, id],
  );

  const clickable = useMemo(
    () => mode !== "print" && mode !== "download",
    [mode],
  );

  // if not has patient user, do not render
  const renderLink = useCallback(
    (children: ReactNode, fileDataId: string) =>
      clickable ? (
        <Link
          target="_blank"
          rel="noopener noreferrer"
          className={styles["block-attachments__link"]}
          to={`/drive/view/${fileDataId}`}
        >
          {children}
        </Link>
      ) : (
        <div className={styles["block-attachments__link"]}>{children}</div>
      ),
    [clickable],
  );

  return !attachmentsById ? null : (
    <div className={styles["block-attachments"]}>
      {mode !== "print" && mode !== "download" && (
        <div className={styles["block-attachments__title"]}>
          {messages.attachments + ":"}
        </div>
      )}
      <ul className={styles["block-attachments__list"]}>
        {attachmentsById.map((el) => (
          <li
            key={el.fileDataId}
            className={getClasses(
              styles["block-attachments__item"],
              clickable && styles["block-attachments__item--link"],
            )}
          >
            {renderLink(
              [
                <TypeIcon
                  key={"type"}
                  mimeType={el.mimeType || getMIMETypeByFileName(el.name)}
                />,
                <div className={styles["block-attachments__name"]} key={"name"}>
                  {el.name}
                </div>,
              ],
              el.fileDataId,
            )}
            {deleteEntry && (
              <Delete
                onDelete={() => deleteEntry({ entryId: el.fileDataId })}
              />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlockAttachments;
